import { useMemo } from "react";
import classNames from "classnames";
import Dropdown from "react-bootstrap/Dropdown";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { CellDropdownItem } from "@idw-types/common";
import styles from "../table-cell-with-dropdown.less";

type TableCellDropdownItemProps = {
    item: CellDropdownItem;
};

export const TableCellDropdownItem = (props: TableCellDropdownItemProps) => {
    const {
        item
    } = props;

    const renderTooltip = (props: any) => {
        return (
            <Tooltip {...props}>{item.disabledText}</Tooltip>
        );
    };

    const dropdownItemElement = useMemo(() => {
        const itemClassNames = classNames(
            styles.dropdownItem,
            item.className ? item.className : "",
            item.disabled ? styles.disabledItem : ""
        );
        return (
            <div>
                <Dropdown.Item
                    id={`dropdown-menu-item-${item.idSuffix}`}
                    className={itemClassNames}
                    as="button"
                    title={item.title}
                    onClick={item.onClick}
                    disabled={item.disabled}
                >
                    <span className={styles.dropdownItemText}>{item.text}</span>
                </Dropdown.Item>
            </div>
        );
    }, [
        item.disabled,
        item.disabledText,
        item.title,
        item.idSuffix,
        item.className,
        item.onClick
    ]);


    return (item.disabled && item.disabledText) ? (
        <OverlayTrigger overlay={renderTooltip}>
            {dropdownItemElement}
        </OverlayTrigger>
    ) : dropdownItemElement;
};